import * as yup from 'yup'

export default function validation(schema) {
  return yup.object().shape({
    productId: yup.number().required(schema.productRequired),
    transactionValue: yup
      .number(schema?.transactionValue?.numeric)
      .positive(schema?.transactionValue?.positive)
      .test('is-decimal', schema?.transactionValue?.invalid, (value) => `${value}`.match(/^[0-9]*\.*[0-9]{0,2}$/))
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .required(schema?.transactionValue?.required),
    payoutValue: yup
      .number(schema?.payoutValue?.numeric)
      .positive(schema?.payoutValue?.positive)
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .test('is-decimal', schema?.payoutValue?.invalid, (value) => `${value}`.match(/^[0-9]*\.*[0-9]{0,2}$/))
  })
}
